const fontWeights = {
  body: 350,
  heading: 625,
  bold: 775,
}

export default fontWeights
